/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Pound = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 14 20">
      <path
        d="M1.05978 20L0.516304 17.3226C1.24094 16.7871 1.79348 16.2427 2.17391 15.6894C2.55435 15.1183 2.78986 14.5382 2.88043 13.9491C2.98913 13.3601 2.98913 12.78 2.88043 12.2088H0V9.12985H2.17391C2.0471 8.64792 1.92935 8.13922 1.82065 7.60375C1.71196 7.06827 1.65761 6.47032 1.65761 5.80991C1.65761 4.56046 1.94746 3.50736 2.52717 2.6506C3.10688 1.79384 3.89493 1.14235 4.8913 0.696118C5.88768 0.232039 7.01993 0 8.28804 0C9.53804 0 10.6612 0.240964 11.6576 0.722892C12.6721 1.18697 13.4783 1.86524 14.0761 2.7577C14.6739 3.63231 14.9819 4.68541 15 5.917L10.7609 6.61312C10.7246 6.09549 10.6159 5.61356 10.4348 5.16734C10.2536 4.72111 9.99094 4.3552 9.64674 4.06961C9.32065 3.76618 8.88587 3.61446 8.34239 3.61446C7.87138 3.61446 7.46377 3.71263 7.11957 3.90897C6.77536 4.10531 6.50362 4.39982 6.30435 4.7925C6.12319 5.16734 6.03261 5.64926 6.03261 6.23829C6.03261 6.68452 6.08696 7.14859 6.19565 7.63052C6.32246 8.11245 6.46739 8.61223 6.63043 9.12985H11.5489V12.2088H7.25543C7.3279 12.9228 7.1558 13.6635 6.73913 14.4311C6.34058 15.1807 5.72464 15.8233 4.8913 16.3588H14.9457V20H1.05978Z"
        fill="#000"
      />
    </BaseSvgIcon>
  )
}

export default Pound
